import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { campaign_item_data } from "../../data/campaign_data";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Collection_items from "../../components/collectrions/Collection_items";
import Image from "next/image";
import Link from "next/link";
import Meta from "../../components/Meta";
import { campaign_detail_page } from "../../services/landing";
import ProSaleBanner from "../../components/ico-landing/ProSaleBanner";
import Cta from "../../components/cta/cta";
import { useDispatch, useSelector } from "react-redux";
import { setItemsTabIndex } from "../../redux/counterSlice";
import AvatorComponentPreview from "../../components/campaigns/AvatorComponentPreview";
export const baseURL = `${process.env.BASE_URL}/`;

const ListCampaignData = [
  {
    campaignId: "",
    campaignName: "",
    amountRaised: "",
    amountTarget: "",
    startDate: "",
    endDate: "",
  },
];
const CampaignPage = () => {
  const [likesImage, setLikesImage] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [data, setData] = useState([]);
  const [campaignDes, setCampaignDes] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { campaignId } = router.query;
  const [apiUpdateData, setApiUpdateData] = useState([]);

  const dispatch = useDispatch();

  // Dispatch the action to update itemsTabIndex
  const handleClick = () => {
    dispatch(setItemsTabIndex(3));
    // setCampaignDes(true);
  };

  useEffect(() => {
    const fetchApi = (myCampaignId) => {
      // getDetails
      if (myCampaignId !== undefined) {
        campaign_detail_page(myCampaignId)
          .then((res) => {
            // debugger
            let tempArray = [];
            const inputString = res?.campaignDetail.overview.description;
            // Split the string into an array of sentences using the period as the delimiter
            const sentencesArray = inputString.split(".");
            const firstSentence = sentencesArray[0].trim();
            setCampaign(res.campaignDetail);
            let dateString = "2023-02-23T18:59:14.000Z";
            let endDateString = "2024-12-15T18:59:14.000Z";
            if (campaignId == "63c42a6b4df378abfe55cd84") {
              const tempData = {
                campaignId: "63c42a6b4df378abfe55cd84",
                campaignName: "Positive Vibes",
                amountRaised: 20000 / 2,
                amountTarget: 20000,
                startDate: "2023-02-15T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              dateString = tempData.startDate;
              endDateString = tempData.endDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "63f51a90c040bbe49f9b0dba") {
              const tempData = {
                campaignId: "63f51a90c040bbe49f9b0dba",
                campaignName: "A World of Wonder",
                amountRaised: 30000 / 3,
                amountTarget: 30000,
                startDate: "2023-02-16T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              dateString = tempData.startDate;
              endDateString = tempData.endDate;

              setApiUpdateData(tempData);
            } else if (campaignId == "6418152cc1877fb6b1264437") {
              const tempData = {
                campaignId: "6418152cc1877fb6b1264437",
                campaignName: "SaferWays Kids",
                amountRaised: 40000 / 3,
                amountTarget: 40000,
                startDate: "2023-02-17T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "64183c3bc1877fb6b12644ab") {
              const tempData = {
                campaignId: "64183c3bc1877fb6b12644ab",
                campaignName: "She Hygiene",
                amountRaised: 50000 / 3,
                amountTarget: 50000,
                startDate: "2023-02-18T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "6416fb5cc1877fb6b1264098") {
              const tempData = {
                campaignId: "6416fb5cc1877fb6b1264098",
                campaignName: "Esther's Orphanage",
                amountRaised: 60000 / 3,
                amountTarget: 60000,
                startDate: "2023-02-19T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "643179e5d001d4fd2f5e63e5") {
              const tempData = {
                campaignId: "643179e5d001d4fd2f5e63e5",
                campaignName: "Road to Education",
                amountRaised: 70000 / 3,
                amountTarget: 70000,
                startDate: "2023-02-20T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "6") {
              const tempData = {
                campaignId: "",
                campaignName: "Canine Superheroes",
                amountRaised: 80000 / 3,
                amountTarget: 80000,
                startDate: "2023-02-21T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "644e1ba84d7c29c3de584700") {
              const tempData = {
                campaignId: "644e1ba84d7c29c3de584700",
                campaignName: "Water for Life",
                amountRaised: 90000 / 2,
                amountTarget: 90000,
                startDate: "2023-02-22T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            } else if (campaignId == "648114bd2e4e15627b786187") {
              const tempData = {
                campaignId: "648114bd2e4e15627b786187",
                campaignName: "Action for Equality",
                amountRaised: 10000 / 4,
                amountTarget: 10000,
                startDate: "2023-02-23T18:59:14.000Z",
                endDate: "2024-12-15T18:59:14.000Z",
              };
              endDateString = tempData.endDate;
              dateString = tempData.startDate;
              setApiUpdateData(tempData);
            }

            // const dateString = res?.campaignDetail.overview.startDate;
            // const endDateString = res?.campaignDetail.overview.endDate;

            const dateObjectStartDate = new Date(dateString);
            const dateObjectEndDate = new Date(endDateString);

            const options = {
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            const formattedDateStartDate =
              dateObjectStartDate.toLocaleDateString("en-US", options);
            const formattedDateEndDate = dateObjectEndDate.toLocaleDateString(
              "en-US",
              options
            );

            const newObj = {
              success: res?.campaignDetail || {},
              username: res?.username || {},
              organization: res?.organization || {},
              assests: res?.assets || {},
              shortDescription: firstSentence,

              details: [
                {
                  id: "07.2K",
                  detailsNumber: res?.campaignDetail.overview.campaignType,
                  detailsText: "Type",
                },

                {
                  id: "22.55",
                  detailsNumber: res?.organization.category,
                  detailsText: "Category",
                },
                // {
                //   id: "317.2K",
                //   detailsNumber: res?.organization.category,
                //   detailsText: "Reg. Number",
                // },

                {
                  id: ".2K",
                  detailsNumber: res?.organization.type,
                  detailsText: "User Type",
                },
                {
                  id: "20K",
                  detailsNumber: formattedDateStartDate,
                  detailsText: "Start Date",
                },
                {
                  id: "30K",
                  detailsNumber: formattedDateEndDate,
                  detailsText: "End Date",
                },
              ],
            };
            tempArray.push(newObj);
            // console.log("This is new Obj", newObj.success.identityVerification);
            setData(tempArray[0]);
            // console.log(tempArray);
            setLoading(true);
            // console.log(newObj);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };
    if (router.isReady) {
      const { campaignId } = router.query;
      if (campaignId === undefined) return null;
      fetchApi(campaignId);
    }
  }, [router.isReady, router.query]);

  useEffect(() => {
    dispatch(setItemsTabIndex(1));
  }, []);

  const handleLikes = () => {
    if (!likesImage) {
      setLikesImage(true);
    } else {
      setLikesImage(false);
    }
  };

  const handleOwnerNameClick = (type) => {
    if (type === "brand") {
      router.push(`/brand/${data.organization._id}`);
    } else if (type === "cause") {
      router.push(`/cause/${data.organization._id}`);
    } else {
      router.push(`/influencers-details/${data.organization._id}`);
    }
  };

  return (
    <>
      <Meta title={`${campaignId} || Impactoverse | Impact NFT Marketplace`} />

      <div className="pt-[5.5rem] lg:pt-24">
        {data !== null ? (
          <div>
            <div>
              <div className="relative h-[300px]">
                <Image
                  src={baseURL + data.success?.overview.bannerImageUrl[0]}
                  alt="banner"
                  width={1519}
                  height={300}
                  className="w-full h-full object-center object-cover"
                />
              </div>
              <section className="dark:bg-jacarta-800 bg-light-base relative pb-12 pt-28">
                {/* <!-- Avatar --> */}
                <AvatorComponentPreview
                  baseURL={baseURL}
                  data={{
                    organization: {
                      logoUrl: data.organization?.logoUrl, // Replace with your actual logo URL
                    },
                    shortDescription: data.shortDescription, // Replace with your actual short description
                  }}
                />

                <div className="container">
                  <div className="text-center">
                    <h2 className="font-display text-jacarta-700 mb-2 text-4xl font-medium dark:text-white">
                      {apiUpdateData.campaignName}
                    </h2>
                    <div>
                      <span className="text-jacarta-400 text-sm font-bold">
                        Created by{" "}
                      </span>
                      <Link
                        href="/user/avatar_6"
                        className="text-accent text-sm font-bold"
                      >
                        {data.username}
                      </Link>
                    </div>
                    <div className="mb-5">
                      <span className="text-jacarta-400 text-sm font-bold">
                        Owned by{" "}
                      </span>
                      <Link
                        href="#"
                        onClick={() =>
                          handleOwnerNameClick(
                            data.organization?.type.toLowerCase()
                          )
                        }
                        className="text-accent text-sm font-bold"
                      >
                        {data.organization?.name}
                      </Link>
                    </div>

                    <div className="dark:bg-jacarta-800 dark:border-jacarta-600 border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white">
                      {data.details?.map(
                        ({ id, detailsNumber, detailsText }) => {
                          return (
                            <Link
                              href="#"
                              key={id}
                              className="dark:border-jacarta-600 border-jacarta-100 w-1/2 rounded-l-xl border-l py-4 hover:shadow-md sm:w-32"
                            >
                              <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white uppercase">
                                {detailsNumber}
                              </div>
                              <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                                {detailsText}
                              </div>
                            </Link>
                          );
                        }
                      )}
                    </div>

                    <p className="dark:text-jacarta-300 text-lg">
                      {campaignDes
                        ? campaign?.overview?.description
                        : data.shortDescription}
                      .{" "}
                      {!campaignDes && (
                        <a
                          href="#section1"
                          // onClick={handleClickReadMore}
                          className="text-accent"
                          onClick={() => handleClick()}
                        >
                          READ MORE.
                        </a>
                      )}
                    </p>

                    {/* Comment this as did not know how it is doing  */}
                    <div className="mt-6 flex items-center justify-center space-x-2.5 relative">
                      <div className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white">
                        {/* <Likes data={} /> */}
                        <div
                          className="js-likes relative inline-flex h-10 w-10 cursor-pointer items-center justify-center text-sm"
                          onClick={() => handleLikes()}
                        >
                          <button>
                            {likesImage ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width={24}
                                height={24}
                                className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-200"
                              >
                                <path fill="none" d="M0 0H24V24H0z" />
                                <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228zm6.826 1.641c-1.5-1.502-3.92-1.563-5.49-.153l-1.335 1.198-1.336-1.197c-1.575-1.412-3.99-1.35-5.494.154-1.49 1.49-1.565 3.875-.192 5.451L12 18.654l7.02-7.03c1.374-1.577 1.299-3.959-.193-5.454z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width={24}
                                height={24}
                                className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-200"
                              >
                                <path fill="none" d="M0 0H24V24H0z" />
                                <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228zm6.826 1.641c-1.5-1.502-3.92-1.563-5.49-.153l-1.335 1.198-1.336-1.197c-1.575-1.412-3.99-1.35-5.494.154-1.49 1.49-1.565 3.875-.192 5.451L12 18.654l7.02-7.03c1.374-1.577 1.299-3.959-.193-5.454z" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>

                      <Social_dropdown />

                      {/* <Auctions_dropdown classes="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white relative" /> */}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* <!-- Profile --> */}

        {/* <!-- end profile --> */}
      </div>
      <Cta
        data={data}
        amountRaised={apiUpdateData.amountRaised}
        targetAmount={apiUpdateData.amountTarget}
      ></Cta>
      <section id="section1">
        <Collection_items
          description={campaign?.overview?.description}
          feasibility={campaign?.feasibility}
          impact={campaign?.impact}
          campaignDes={campaign?.overview?.description}
          isSuperCampaign={campaign.overview?.isSuperCampaign}
          campaignId={campaignId}
        />
      </section>
    </>
  );
};

export default CampaignPage;
